import React from 'react'

import Carousel from 'react-multi-carousel'
import { defaultCarouselProps } from 'shared/components'
import { useWindowSize } from 'shared/hooks'

import { promotionalMaterialsItems } from './items'

import 'react-multi-carousel/lib/styles.css'
import carouselClasses from 'styles/carousel.module.scss'
import classes from './PromotionalMaterials.module.scss'

export const PromotionalMaterials = (): JSX.Element => {
  const carouselProps = defaultCarouselProps(true, {
    largeDesktop: 3,
    mediumDesktop: 3,
    desktop: 2,
    tablet: 2,
    mobile: 1,
    desktopPartialVisible: 60,
    tabletPartialVisible: 60,
  })
  const { isTablet, isMobile, isSmallDesktop } = useWindowSize()

  return (
    <div className={classes.wrapper}>
      <div className={`${classes.container} container`}>
        <h2
          className={`${classes.title} second-title  reveal-from-bottom-medium`}
          data-reveal-delay={50}
        >
          ВАРИАНТЫ РЕКЛАМНЫХ{'\n'}МАТЕРИАЛОВ
        </h2>
        <div
          className={`${classes['carousel-container']} reveal-from-bottom-medium`}
          data-reveal-delay={50}
        >
          <Carousel
            {...carouselProps}
            showDots={isTablet || isMobile}
            dotListClass={carouselClasses.dotList}
            containerClass={`${classes.carousel_row} row`}
            itemClass={`${classes.carousel_item} col-xs-12 col-sm-12 col-md-3 col-lg-3`}
            partialVisbile={isTablet || isSmallDesktop}
          >
            {promotionalMaterialsItems.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className={classes.item}
                style={{ backgroundImage: `url(${item.src})` }}
              >
                {item.title}
              </div>
            ))}
          </Carousel>
        </div>
        <small>
          *Объем и перечень рекламных материалов определяется условиями
          сотрудничества с партнером
        </small>
      </div>
    </div>
  )
}
